import { render, staticRenderFns } from "./PopUpModalComponent.vue?vue&type=template&id=785dc763&scoped=true&"
import script from "./PopUpModalComponent.vue?vue&type=script&lang=ts&"
export * from "./PopUpModalComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpModalComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PopUpModalComponent.vue?vue&type=style&index=1&id=785dc763&lang=scss&scoped=true&"
import style2 from "./PopUpModalComponent.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785dc763",
  null
  
)

export default component.exports